import type { CSSProperties } from 'react';
import type { InlineNode } from '..';
import { SerializeTextLeaf, type TTextLeaf } from '../textLeaf';
import { isHardBreakNode } from '../utils/isHardBreakNode';
import * as styles from './ListItem.css';

type ListItemProps = {
  inlineNodes: InlineNode[];
};

export const ListItem = (props: ListItemProps) => {
  const { inlineNodes } = props;

  const firstBasicText = inlineNodes.find((node): node is TTextLeaf => !isHardBreakNode(node));

  //   find relevant marks for the li, like text color
  const textStyle = firstBasicText?.marks?.find((mark) => mark.type === 'textStyle');

  return (
    <li
      className={styles.listItemElement}
      style={
        {
          '--color': textStyle?.attrs?.color,
          '--font-size': textStyle?.attrs?.fontSize,
          '--mobile-font-size': textStyle?.attrs?.mobileFontSize,
          '--line-height': textStyle?.attrs?.lineHeight,
          '--mobile-line-height': textStyle?.attrs?.mobileLineHeight,
        } as CSSProperties
      }
    >
      {inlineNodes
        .filter((node): node is TTextLeaf => !isHardBreakNode(node))
        .map((node, index) => (
          <SerializeTextLeaf key={`${node.id}-${index}`} leaf={node} />
        ))}
    </li>
  );
};
